import api from "../lib/axios";

export const getOrderById = async (orderId: string) => {
  const { data } = await api.get(`/order/${orderId}`);
  return data;
};

export const getOrders = async (params: {
  search?: string;
  startTime: string;
  endTime: string;
  status?: string;
}) => {
  const { data } = await api.get("order/orders", { params });
  return data;
};

export const getOrderDetails = async (orderId: string) => {
  const { data } = await api.get(`/order/order-details?id=${orderId}`);
  return data;
};

export const saveOrder = async (
  order: Record<string, unknown>,
  imageFiles?: Record<string, File>,
) => {
  const formData = new FormData();
  formData.append("data", JSON.stringify(order));
  if (imageFiles) {
    for (const [lineItemId, file] of Object.entries(imageFiles)) {
      formData.append(`image:${lineItemId}`, file);
    }
  }
  // Override the axios instance's default "application/json" Content-Type so
  // the browser/axios sends multipart/form-data with the correct boundary.
  await api.put("/order", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const parsePartNumber = async (
  imageFile: File,
  serviceType: string,
  orderId: string,
) => {
  const formData = new FormData();
  formData.append("image", imageFile);
  formData.append("serviceType", serviceType);
  formData.append("orderId", orderId);

  const { data } = await api.post("/order/parse-part-number", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

  return data;
};
